import { API, graphqlOperation } from 'aws-amplify';
import { loginCognitoUser } from '../../graphql';
import { validateUserSession } from './validateUserSession';

export const tokenRefreshInDb = async (): Promise<boolean> => {
  try {
    const currentSession = localStorage.getItem('deviceKey');
    
    if (!currentSession) {
      console.log('No deviceKey found in localStorage');
      return false;
    }

    console.log('Starting token refresh for session:', currentSession);
    
    // Use the new session validation function
    const validationResult = await validateUserSession();
    
    if (validationResult.isValid) {
      console.log('Session is valid, refreshing token...');
      await API.graphql(
        graphqlOperation(loginCognitoUser, {
          LinkedSessionID: currentSession,
        })
      );
      console.log('Token refresh completed successfully');
      return true;
    } else {
      console.log('Session validation failed:', validationResult.error);
      console.log('Skipping token refresh due to invalid session');
      return false;
    }
  } catch (err) {
    console.error('Token refresh error:', err);
    return false;
  }
};
